(function () {
  'use strict';

  angular.module('app').component('tourPage', tourDetailCtrl());

  function tourDetailCtrl() {
    return {
      bindings: {},
      controller: TourDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tours/tour-page.component.html',
    };
  }

  TourDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'SessionService',
    'TourService',
    'LanguageService',
  ];

  function TourDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    SessionService,
    TourService,
    LanguageService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_tour_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.activeTab = $routeParams.activeTab;

    // Methods
    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Initializers
    // getTour();
    getAdditionalLanguages();

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getTour();
      });
    }

    function getTour() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        TourService.getTour(itemId, { lang: vm.defaultLanguage, show_contents: true }).then(
          function (data) {
            vm.item = data;

            vm.loadingItem = false;
          }
        );
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/tours/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/tours');
    }
  }
})();
